import {useEffect, useRef, useState} from 'react'

// Animates a number from its previous value to the new one.
export const useCountUp = (target: number, duration = 700): number => {
	const [value, setValue] = useState(0)
	const from = useRef(0)

	useEffect(() => {
		const start = performance.now()
		const begin = from.current
		let frame = 0

		const tick = (time: number) => {
			const progress = Math.min((time - start) / duration, 1)
			const eased = 1 - Math.pow(1 - progress, 3)
			const next = Math.round(begin + (target - begin) * eased)
			setValue(next)
			from.current = next
			if (progress < 1) frame = requestAnimationFrame(tick)
		}

		frame = requestAnimationFrame(tick)
		return () => cancelAnimationFrame(frame)
	}, [target, duration])

	return value
}
